import React, { useContext, useState } from 'react';
import { StateContext } from '../../StateContext';
import axios from 'axios';
import './login.css';
import PasswordField from './password';
import { TextField } from '@mui/material';
import { loginCall } from '../../Services/APICalls/apicalls';
import { PageItems } from '../index';
import { useLanguage } from '../../Services/LanguageContext';
axios.defaults.withCredentials = true;

const LoginPage = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { t, language, setLanguage } = useLanguage();

    const { setLoginData, setPage } = useContext(StateContext);

    const loginHandler = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        await loginCall(userName, password, setLoginData);
        setIsSubmitting(false);
        setPassword('');
    };

    const goToRegister = () => {
        setPage(PageItems.REGISTER);
    };

    return (
        <div className='login-container'>
            <button
                className='login-lang-toggle'
                onClick={() => setLanguage(language === 'nl' ? 'en' : 'nl')}
                title={t('switchToLanguage')}
            >
                {language === 'nl' ? '🇬🇧 EN' : '🇳🇱 NL'}
            </button>

            <div className='login-card'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img
                        className='login-logo'
                        src='https://www.j-twee.nl/wp-content/themes/jtwee/img/logo.png'
                        alt='Logo'
                    />
                    <h1 className='login-title'>{t('login')}</h1>
                    <p className='login-subtitle'>
                        {t('signInToAccount')}
                    </p>
                </div>

                <form className='login-form' onSubmit={loginHandler} action='#'>
                    <TextField
                        label={t('username')}
                        type='text'
                        variant='outlined'
                        value={userName}
                        onChange={(x) => setUserName(x.target.value)}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                background: 'var(--bg-tertiary)',
                            },
                        }}
                    />
                    <PasswordField value={password} onChange={setPassword} />
                    <button type='submit' className='btn-login' disabled={isSubmitting}>
                        {isSubmitting ? 'Bezig...' : t('login')}
                    </button>
                </form>

                <div className='login-divider'>
                    {t('or')}
                </div>

                <button onClick={goToRegister} className='btn-register'>
                    {t('register')}
                </button>
            </div>
        </div>
    );
};

export default LoginPage;
